"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when the user's subscription is invalid on resource fetch
 * e.g. fetching a course with no premium enrollments remaining
 * @param {string} message
 */
class SubscriptionNotValidError extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
    }
}
exports.default = SubscriptionNotValidError;
//# sourceMappingURL=SubscriptionNotValidError.js.map